'use client';
import { useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { colorArray } from '@/utils/Colors';
import { ChevronDown } from 'react-feather';
import classes from './FilterComps.module.css';

const ColorFilter = (props) => {
	const { theColor } = props;

	const router = useRouter();
	const pathname = usePathname();

	const [showColors, setShowColors] = useState(false);

	const updateURL = (params) => {
		router.replace(pathname + '?' + params);
	};

	const colorFilter = (color) => {
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('color');
		updateURL(newParams + `&color=${color.name}`);
	};

	const clearHandler = () => {
		setShowColors(true);
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('color');
		updateURL(newParams + '');
	};

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div
						onClick={() => setShowColors(!showColors)}
						className={classes.justifyBetween}
					>
						Color
						<ChevronDown
							className={showColors ? classes.flip : classes.icon}
							size={13}
						/>
					</div>

					{showColors && (
						<div className={classes.boxColor}>
							{colorArray.map((color, idx) => {
								const isActive = theColor === color.name;
								return (
									<div
										onClick={isActive ? clearHandler : () => colorFilter(color)}
										key={color.name}
										className={classes.colorFilterBox}
									>
										<div
											className={
												isActive ? classes.colorRoundActive : classes.colorRound
											}
											style={{ background: color.code }}
										/>
										<div
											value={color.name}
											className={
												isActive ? classes.activeColor : classes.selectionColor
											}
										>
											{color.name}
										</div>
									</div>
								);
							})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default ColorFilter;
